export const warmthLabel = (w) => {
  if (w >= 75) return "Strong";
  if (w >= 55) return "Warm";
  if (w >= 40) return "Neutral";
  return "Building";
};

export const sentimentTone = {
  "Highly Engaged": "text-emerald-700 dark:text-emerald-400",
  Positive: "text-emerald-700 dark:text-emerald-400",
  Neutral: "text-muted-foreground",
  Cautious: "text-amber-700 dark:text-amber-400",
  Skeptical: "text-rose-700 dark:text-rose-400",
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const fmtTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
};
